(function () {
  var _lastCanonicalKey = null;

  function getListValue() {
    try {
      var stored = localStorage.getItem('ua-breadcrumbs');
      if (!stored) return '';
      var url = JSON.parse(stored).collection.url;
      if (!url) return '';
      return url.replace(/^https?:\/\/[^/]+/, '');
    } catch (e) {
      return '';
    }
  }

  function buildPayload(raw) {
    var variantId = raw.variantId ? String(raw.variantId) : null;
    var productId = raw.productId ? String(raw.productId) : null;
    var canonicalKey = variantId || productId;

    if (!canonicalKey) return null;

    var payload = {
      canonicalKey: canonicalKey,
      variantId: variantId,
      productId: productId
    };

    if (raw.sku) payload.sku = String(raw.sku);
    if (raw.productName) payload.productName = String(raw.productName);
    if (raw.variantName) payload.variantNameRaw = String(raw.variantName);
    if (raw.variantName && raw.variantName !== 'Default Title') payload.variantName = String(raw.variantName);
    if (raw.price != null && !isNaN(raw.price)) payload.price = parseFloat(raw.price);
    if (raw.compareAtPrice != null && !isNaN(raw.compareAtPrice) && raw.compareAtPrice > 0) payload.compareAtPrice = parseFloat(raw.compareAtPrice);
    if (raw.currency) payload.currency = String(raw.currency);
    if (raw.brand) payload.brand = String(raw.brand);
    if (raw.category) payload.category = String(raw.category);

    return payload;
  }

  function pushGAViewItem(payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });

    var item = { item_id: payload.canonicalKey, quantity: 1 };
    if (payload.productName) item.item_name = payload.productName;
    if (payload.variantName) item.item_variant = payload.variantName;
    if (payload.price != null && payload.currency) item.price = payload.price;
    if (payload.brand) item.item_brand = payload.brand;
    if (payload.category) item.item_category = payload.category;

    var ecommerce = { items: [item] };
    if (payload.price != null && payload.currency) {
      ecommerce.currency = payload.currency;
      ecommerce.value = payload.price;
    }

    var list = getListValue();
    var detailProduct = {
      id: payload.sku || payload.canonicalKey,
      name: payload.productName || '',
      brand: payload.brand || '',
      category: payload.category || '',
      variant: payload.variantNameRaw || '',
      price: payload.price != null ? payload.price.toFixed(2) : '',
      list: list,
      product_id: payload.productId || '',
      variant_id: payload.variantId || ''
    };
    if (payload.compareAtPrice != null) {
      detailProduct.compare_at_price = payload.compareAtPrice.toFixed(2);
    }

    if (payload.currency) ecommerce.currencyCode = payload.currency;
    ecommerce.detail = {
      actionField: { list: list },
      products: [detailProduct]
    };

    window.dataLayer.push({ event: 'dl_view_item', ecommerce: ecommerce });
  }

  function pushMetaViewContent(payload) {
    if (typeof fbq !== 'function') return;

    var data = {
      content_ids: [payload.canonicalKey],
      content_type: 'product'
    };
    if (payload.productName) data.content_name = payload.productName;
    if (payload.price != null && payload.currency) {
      data.value = payload.price;
      data.currency = payload.currency;
    }

    fbq('track', 'ViewContent', data);
  }

  window.uaSwapTracking = {
    fireSwapEvent: function (raw) {
      var payload = buildPayload(raw);
      if (!payload) return;
      if (payload.canonicalKey === _lastCanonicalKey) return;
      _lastCanonicalKey = payload.canonicalKey;

      pushGAViewItem(payload);
      pushMetaViewContent(payload);
    }
  };
})();
